export const useGetParams = () => {
  const searchParams = new URL(document.location).searchParams;
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',
    titleBottom: getDefaultValue(
      searchParams.get('titleBottom'),
      `#Территория Полюса, перекличка.#\\n
      Отсканируйте QR-код.\\n
      Напишите в чат из какого вы города.`,
    ),
    title: getDefaultValue(
      searchParams.get('title'),
      'Напишите в чат из какого вы города',
    ),
    qrCode1: searchParams.get('qrCode1'),
    titleFontSize: searchParams.get('titleFontSize') || '4',
    sizeQR: searchParams.get('sizeQR') || '21.5',
    minFontWords: searchParams.get('minFontWords') || 30,
    maxFontWords: searchParams.get('maxFontWords') || 70,
    requestInterval: Number(searchParams.get('requestInterval') || 2000),
    demo: searchParams.get('demo') || false,
  };
};
